/**
 * ExpandAllIcon/index.js
 * desc: system icon used to expand all content
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ExpandAllIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="expand-all icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.expandAll.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18.462 0H4.615C3.77 0 3.077.846 3.077 1.88v1.196H1.539C.692 3.076 0 3.922 0 4.956V18.12C0 19.154.692 20 1.539 20h13.846c.846 0 1.539-.846 1.539-1.88V4.957c0-1.035-.693-1.88-1.539-1.88H4.615V1.88h13.847v13.163h-1.538v1.88h1.538c.846 0 1.538-.845 1.538-1.88V1.88C20 .846 19.308 0 18.462 0zM1.538 18.12h13.847V4.959H1.538v13.163zm7.39-5.858H12.5v-1.19H8.93V7.5h-1.19v3.572H4.166v1.19h3.571v3.572h1.19v-3.572z"/></svg>
    </IconButton>
);



export default ExpandAllIcon;
